import React from 'react';
import { RenderModule } from 'holocron';
import clsx from 'clsx';
import { ProgressCircular } from '@americanexpress/dls-react';
import { useSelector } from 'react-redux';
import { getActiveLocaleSelector } from '@americanexpress/travel-selectors';
import { usePersonaArticles } from '../../hooks/usePersonaApi';
import { FOR_YOU_MODULE_NAME } from '../../constants/modules';
import style from './ForYou.scss';

const ForYou = () => {
  const {
    heading,
    articles,
    personaType,
    isLoading: personaLoading,
  } = usePersonaArticles();
  const locale = useSelector(getActiveLocaleSelector);

  if (personaLoading) {
    return (
      <div className={clsx('container flex flex-justify-center flex-align-center', style.loaderContainer)}>
        <ProgressCircular size="lg" />
      </div>
    );
  }

  if (articles.length === 0) {
    return null;
  }

  const [, market] = locale.toLowerCase().split('-');
  const analyticsElementPrefix = `${market}hp-foryou-${personaType}`;

  return (
    <div data-testid="axp-travel-home-just-for-you" className="pad-4-b pad-t-xs-down">
      <RenderModule
        moduleName={FOR_YOU_MODULE_NAME}
        props={{
          heading,
          articles,
          analyticsElementPrefix,
        }}
      />
    </div>
  );
};

export default ForYou;
